import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20entertainment%20media%20background%20with%20flowing%20gradients%20of%20warm%20orange%20and%20teal%20tones%2C%20soft%20cinematic%20glow%20effects%2C%20modern%20minimal%20design%2C%20smooth%20curves%2C%20digital%20art%20style&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="俺去也娱乐平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
          海量资源，<span className="text-primary-400">免费观看</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          俺去也致力于打造最优质的娱乐内容平台。五万部高清视频资源，每日持续更新，
          无需注册，打开即看。电视剧、电影、综艺、动漫、纪录片，你想看的这里都有。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/dianshi"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all whitespace-nowrap shadow-lg hover:shadow-xl"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观看
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full transition-all whitespace-nowrap backdrop-blur-sm border border-white/20"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>

        <div className="mt-10 md:mt-14 flex items-center justify-center gap-8 md:gap-12">
          {[
            { value: '50,000+', label: '高清资源' },
            { value: '8,000万', label: '活跃用户' },
            { value: '200+', label: '每日更新' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-heading font-bold text-white">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}